import React from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';
import PasswordInput from '../../common/PasswordInput';

interface Props {
  handleNewPassword: (value: any) => any;
  loading: boolean;
}

export default class NewPassword extends React.Component<Props> {
  removeAtribute = (id) => {
    const fieldEl = document.getElementById(id);
    if (fieldEl) fieldEl.removeAttribute('readOnly');
  };

  render() {
    const { loading, handleNewPassword } = this.props;

    const validationSchema = yup.object().shape({
      password: yup.string().required('New Password is Required'),
      repeatPassword: yup
        .string()
        .required('Repeat Password again')
        .test('match', 'password do not match', function (confirmPassword) {
          return confirmPassword === this.parent.password;
        })
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
          'Must Contain atleast 8 Characters, and atleast One Uppercase, One Lowercase, One Number and One Special Case Character',
        ),
    });

    return (
      <Formik
        validationSchema={validationSchema}
        initialValues={{
          password: '',
          repeatPassword: '',
        }}
        onSubmit={handleNewPassword}
      >
        {({ values, errors, handleSubmit, handleChange, handleBlur, setFieldValue, touched }) => (
          <form onSubmit={handleSubmit} autoComplete="off">
            <div className={`${!errors.password ? 'form-group' : ''} pb-2`}>
              <label className="grey-10 mb-1">Password</label>
              <PasswordInput
                id="password"
                className="form-control px-3"
                placeholder="Enter your password here"
                autoComplete="off"
                value={values.password}
                readOnly={true}
                onChange={handleChange}
                onBlur={handleBlur}
                onFocus={() => this.removeAtribute('password')}
              />
              {errors.password && touched.password && (
                <div className="text-danger mt-2 ml-2">{String(errors.password)}</div>
              )}
            </div>
            <div className={`${!errors.password ? 'form-group' : ''} pb-2`}>
              <label className="grey-10 mb-1">Repeat Password</label>
              <PasswordInput
                id="repeatPassword"
                className="form-control px-3"
                placeholder="Enter password again"
                autoComplete="off"
                value={values.repeatPassword}
                readOnly={true}
                onChange={handleChange}
                onBlur={handleBlur}
                onFocus={() => this.removeAtribute('repeatPassword')}
              />
              {errors.repeatPassword && touched.repeatPassword && (
                <div className="text-danger mt-2 ml-2">{String(errors.repeatPassword)}</div>
              )}
            </div>
            <button
              disabled={loading}
              id="default_FsContainedButton"
              type="submit"
              className="btn btn-secondary btn-xl d-block w-100 mt-4 mb-4"
            >
              Update Password
            </button>
          </form>
        )}
      </Formik>
    );
  }
}
